import { render, staticRenderFns } from "./PatentWorkingReminderList.vue?vue&type=template&id=6ef6ad5a&"
import script from "./PatentWorkingReminderList.vue?vue&type=script&lang=js&"
export * from "./PatentWorkingReminderList.vue?vue&type=script&lang=js&"
import style0 from "./PatentWorkingReminderList.vue?vue&type=style&index=0&id=6ef6ad5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports